var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('modal',{attrs:{"transition-name":"fade-side","appear":"","comp":_vm.linkedInWaitingComponent,"removesso":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }